export enum ObservationDirectionEnum {
  Inbound = 'Inbound',
  Outbound = 'Outbound'
}

export enum FuelTypeEnum {
  Diesel = 'Diesel',
  Electric = 'Electric',
  FuelCell = 'FuelCell',
  Gasoline = 'Gasoline',
  NaturalGas = 'NaturalGas',
  Propane = 'Propane',
  Unavailable = 'Unavailable'
}

export enum VehicleClassEnum {
  Three = '<2b',
  Seven = '2b-7',
  Eight = '8'
}

export enum AssetTypeEnum {
  Container = 'Container',
  ContainerReefer = 'ContainerReefer',
  DryVan = 'DryVan',
  DryVanReefer = 'DryVanReefer',
  Flatbed = 'Flatbed',
  Chassis = 'Chassis'
}

export interface ObservationMatchAttributes {
  dotNumber?: string;
  licensePlate?: string;
}

export interface ObservationMatchTimeWindow {
  start: Date;
  end: Date;
}
